// 花名册变更流程详情
<style scoped>
.textl {
  position: relative;
}
#mobilePhoneNumbers {
  position: absolute;
  top: 17px;
  left: -8px;
  width: 500px;
}

.afterTheChange {
  margin-left: 10px;
  display: inline-block;
}

.textl {
  text-align: left;
}

.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
  margin-bottom: 50px;
}

.file-name:hover {
  color: #4fa1a4;
  cursor: pointer;
}

.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}

.my-active-file {
  display: flex;
  width: 700px;
}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}

.pdt100 {
  padding-bottom: 100px !important;
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
}

.import-title.second {
  margin-top: 4px;
}

.header .title {
  text-align: center;
  flex: 1;
}

.customer-information {
  background: #fff;
  padding-bottom: 0px;
  font-size: 14px;
}

.customer-information .cols {
  background: #fff;
  display: flex;
  padding: 8px 16px;
  padding-left: 20px;
  width: 960px;
  flex-wrap: wrap;
}

.customer-information .col-itms {
  display: flex;
  /* align-items: center; */
  margin-left: 20px;
  margin-bottom: 20px;
}

.customer-information .col-itms .title {
  width: 150px;
  text-align: right;
  color: #666;
  /* margin-right: 16px; */
}

.customer-information .col-itms.second {
  margin-left: 100px;
}

.customer-information .col-itms .title span {
  color: red;
  display: none;
}

.import-new-wrap {
  padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
  text-align: left;
  padding-left: 170px;
}

.import-new-wrap .col-itms {
  align-items: baseline;
}

.operte-btns {
  position: fixed;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
  background: #fff;
  margin-top: 4px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
}

.operte-btns .btn.save {
  margin: 0 10px;
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}

.detail-btn {
  font-size: 14px;
  color: #4fa1a4;
  margin-left: 30px;
  cursor: pointer;
}

.file {
  display: flex;
  margin-bottom: 14px;
  text-align: left;
  align-items: center;
}

.file img {
  width: 32px;
  height: 32px;
  margin-right: 10px;
}

.w300 {
  margin-left: 10px;
}

#forbiddenText .col-itms {
  display: block;
  width: 100%;
  margin-left: 10%;
}

#forbiddenText .col-itms .title {
  text-align: left;
  margin-left: 10px;
  width: 100%;
}

#forbiddenText .col-itms .textl {
  border: 1px solid #ccc;
  width: 100% !important;
  height: 48px;
  background-color: #f5f5f5;
  padding: 5px;
  margin-top: 8px;
}
.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* .basicInformation{
  
} */
/* #mobilePhoneNumber{
  position: relative;
  top: 4px;
    left: -75px;
} */
</style>

<style lang="less" scoped>
.cardboxStyle {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-left: 5%;
  .cardStyle {
    /* width: 363px; */
    width: 97%;
    height: 150px;
    margin: 6px;
    margin-top: 0px;
    border: 1px solid #d9d9d9;
    .gongSi {
      text-align: left;
      font-size: 16px;
      font-weight: 700;
      margin: 12px 80px 12px 16px;
    }
    .sangeSpan {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      color: #666666;
      width: 320px;
      height: 63px;
      margin: 15px 35px 17px 16px;
    }
    .classNames {
      width: 300px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 4px;
    }
  }
}
.active {
  background-color: #ebf6f7;
}
</style>

<template>
  <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="header">
      <div class="back" @click="$router.go(-1)">返回</div>
      <div class="title">{{ prevForm.flowName }}</div>
    </div>
    <div class="import-title second">申请信息</div>
    <div class="customer-information">
      <div class="cols">
        <div class="col-itms">
          <div class="title"><span>*</span>申请人：</div>
          <div class="label textl">{{ prevForm.staffName }}</div>
        </div>
        <div class="col-itms">
          <span style="margin: 0 30px 0 20px; color: #e5e5e5">|</span>
          <div>提交时间：</div>
          <div class="label textl">{{ prevForm.createTime | getTime }}</div>
          <span style="margin: 0 20px 0 30px; color: #e5e5e5">|</span>
        </div>
        <div class="col-itms">
          <div>所在部门：</div>
          <div class="label textl">{{ prevForm.organisationName }}</div>
        </div>
      </div>
      <!-- //! 花名册删除原因 -->
      <div class="cols" v-if="changeCause">
        <div class="col-itms">
          <div class="title" style="color: red">删除原因：</div>
          <div class="label textl">{{ changeCause }}</div>
        </div>
      </div>
    </div>
    <!-- :id="m.sourceName === '背调结果信息' ? 'forbiddenText' : ''" -->
    <section v-for="(m, n) in formConfigList" :key="n">
      <template v-if="m.displayFlag && m.sourceName !== hisInfoCom">
        <!-- <div class="import-title second" v-if="m.sourceName === '入职信息'">{{ m.sourceName }}</div> -->
        <div class="import-title second" >{{ m.sourceName }}</div>
        <div class="customer-information">
          <!-- 入职公司信息 -->
          <!-- <div v-if="m.sourceName === '备案信息'" class="cardboxStyle">
            <div
              v-for="(item, index) in changeCompany"
              :key="index"
            >
              <div class="cardStyle active">
                <div class="gongSi">{{ item.companyName }}</div>
                <div class="sangeSpan">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :content="`${Array.isArray(item.organs) ? item.organs.join('、') : '-'}`"
                  >
                    <div slot="reference">
                      <div class="classNames">
                        所在组织:
                        <span v-if="Array.isArray(item.organs) && item.organs.length">
                          <span v-for="(item, index) in item.organs" :key="index">
                            <span style="margin-left: 8px">{{ item }}</span>
                          </span>
                        </span>
                        <span style="margin-left: 8px" v-else>-</span>
                      </div>
                    </div>
                  </el-popover>
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :content="`${Array.isArray(item.positionNames) ? item.positionNames.join('、') : '-'}`"
                  >
                    <div slot="reference">
                      <div class="classNames">
                        所在岗位:
                        <span v-if="Array.isArray(item.positionNames) && item.positionNames.length">
                          <span v-for="(item, index) in item.positionNames" :key="index">
                            <span style="margin-left: 8px">{{ item }}</span>
                          </span>
                        </span>
                        <span style="margin-left: 8px" v-else>-</span>
                      </div>
                    </div>
                  </el-popover>
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :content="`${Array.isArray(item.salesTerritory) ? item.salesTerritory.join('、') : '-'}`"
                  >
                    <div slot="reference">
                      <div class="classNames">
                        销售区域:
                        <span v-if="Array.isArray(item.salesTerritory) && item.salesTerritory.length">
                          <span v-for="(item, index) in item.salesTerritory" :key="index">
                            <span style="margin-left: 8px">{{ item }}</span>
                          </span>
                        </span>
                        <span style="margin-left: 8px" v-else>-</span>
                      </div>
                    </div>
                  </el-popover>
                    <div slot="reference">
                      <div class="classNames">
                        备案日期:
                        <span v-if="item.createTime">
                          <span class="jianJu">{{ item.createTime | getDate }}</span>
                        </span>
                        <span style="margin-left: 8px" v-else>-</span>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="cols">
            <div class="col-itms" v-for="(j, k) in m.mapping" :key="k" v-show="j.displayFlag == 1">
              <div class="title" id="item">{{ j.sourceName }}：</div>

              <!-- {{ getValue(j, 'update', 0)||'-' }} -->
              <!-- 变更前 -->
              <template>
                <div v-if="operateState == 'update'" class="label w300 textl">
                  <!-- {{ getValue(j, 'update', 0)||'-' }} -->
                  <div v-if="imgDisplayArea_2.includes(j.sourceKey)">
                    <div v-if="!getValue(j, 'update', 0)">
                      {{ getValue(j, 'update', 0) || '-' }}
                    </div>
                    <template v-else>
                      <div class="my-active-file" v-for="childItemx in getValue(j, 'update', 0)" :key="childItemx.path">
                        <template>
                          <div class="file-name w250 nowrap" :title="childItemx.fileName || childItemx.name">
                            {{ childItemx.fileName || childItemx.name }}
                          </div>
                          <div class="file-preview" @click="onPreview(childItemx.path)">查看</div>
                          <div class="file-preview" @click="onDownload(childItemx.path)">下载</div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <img
                    v-else-if="imgDisplayArea_1.includes(j.sourceKey)"
                    width="200"
                    :src="getValue(j, 'update', 0)"
                    alt=""
                  />
                  <span v-else>{{ getValue(j, 'update', 0) || '-' }}</span>
                  <!-- 判空 start -->
                  <span v-if="getValue(j, 'update', 1)" :id="j.sourceKey === 'mobileNo' ? 'mobilePhoneNumbers' : ''">
                    <!-- 变更后 -->
                    <!-- 处理 -->

                    <span
                      style="color: red"
                      class="afterTheChange"
                      :id="j.sourceKey === 'mobileNo' ? 'mobilePhoneNumber' : ''"
                    >
                      <div v-if="imgDisplayArea_2.includes(j.sourceKey)">
                        <div v-if="!getValue(j, 'update', 1)">
                          {{ getValue(j, 'update', 1) || '-' }}
                        </div>

                        <template v-else>
                          <!-- 判断是否删除附件 -->
                          <template v-if="getValue(j, 'update', 1).length">
                            <div
                              class="my-active-file"
                              v-for="childItemx in getValue(j, 'update', 1)"
                              :key="childItemx.path"
                            >
                              <template>
                                <div class="file-name w250 nowrap" :title="childItemx.fileName || childItemx.name">
                                  {{ childItemx.fileName || childItemx.name }}
                                </div>
                                <div class="file-preview" @click="onPreview(childItemx.path)">查看</div>
                                <div class="file-preview" @click="onDownload(childItemx.path)">下载</div>
                              </template>
                            </div>
                          </template>
                          <template v-else-if="j.sourceKey !== 'joinAge' && j.sourceKey !== 'age'"
                            >变更后:{{ '内容已删除' }}</template
                          >
                        </template>
                      </div>
                      <img
                        v-else-if="imgDisplayArea_1.includes(j.sourceKey)"
                        width="200"
                        :src="getValue(j, 'update', 1)"
                        alt=""
                      />
                      <span v-else-if="j.sourceKey !== 'joinAge' && j.sourceKey !== 'age'"
                        >变更后:{{ getValue(j, 'update', 1) || '内容已删除' }}</span
                      >
                    </span>
                  </span>
                  <!-- 判空 end -->
                  <!-- 捕捉删除的内容 -->
                  <span
                    v-else-if="initValueNew && initValueNew.hasOwnProperty(j.sourceKey)"
                    :id="j.sourceKey === 'mobileNo' ? 'mobilePhoneNumbers' : ''"
                  >
                    <span
                      style="color: red"
                      class="afterTheChange"
                      :id="j.sourceKey === 'mobileNo' ? 'mobilePhoneNumber' : ''"
                    >
                     变更后:{{ getValue(j, 'update', 1) || '内容已删除' }}
                    </span>
                  </span>
                </div>
              </template>

              <div v-if="operateState == 'add'" class="label w300 textl">
                <template>
                  <div v-if="imgDisplayArea_2.includes(j.sourceKey)">
                    <div v-if="!getValue(j, 'add')">-</div>
                    <template v-else>
                      <div class="my-active-file" v-for="childItemx in getValue(j, 'add')" :key="childItemx.path">
                        <template>
                          <div class="file-name w250 nowrap" :title="childItemx.fileName || childItemx.name">
                            {{ childItemx.fileName || childItemx.name }}
                          </div>
                          <div class="file-preview" @click="onPreview(childItemx.path)">查看</div>
                          <div class="file-preview" @click="onDownload(childItemx.path)">下载</div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <img
                    v-else-if="imgDisplayArea_1.includes(j.sourceKey)"
                    width="200"
                    :src="getValue(j, 'add')"
                    alt=""
                  />
                  <span v-else>{{ getValue(j, 'add') || '-' }}</span>
                </template>
              </div>
              <div v-if="operateState == 'del'" class="label w300 textl">
                <!-- {{ getValue(j, 'del')||'-' }} -->
                <div v-if="imgDisplayArea_2.includes(j.sourceKey)">
                  <div v-if="!getValue(j, 'del')">-</div>
                  <template v-else>
                    <div class="my-active-file" v-for="childItemx in getValue(j, 'del')" :key="childItemx.path">
                      <template>
                        <div class="file-name w250 nowrap" :title="childItemx.fileName || childItemx.name">
                          {{ childItemx.fileName || childItemx.name }}
                        </div>
                        <div class="file-preview" @click="onPreview(childItemx.path)">查看</div>
                        <div class="file-preview" @click="onDownload(childItemx.path)">下载</div>
                      </template>
                    </div>
                  </template>
                </div>
                <img v-else-if="imgDisplayArea_1.includes(j.sourceKey)" width="200" :src="getValue(j, 'del')" alt="" />
                <span v-else>{{ getValue(j, 'del') || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 其他入职信息特殊处理(取/staff-roster/profile接口) -->
      <template v-else-if="m.displayFlag && m.sourceName === hisInfoCom && otherCompanies.length">
        <div class="import-title second">{{ hisInfoCom }}</div>
        <div class="customer-information">
          <!-- 入职公司信息 start-->
          <div class="cardboxStyle">
            <div
              v-for="(item, index) in otherCompanies"
              :key="index"
              @click="dynamicDisplay(item)"
            >
              <div class="cardStyle" :class="[isActive == index ? 'active' : '']" @click="styleChanges(index)">
                <div class="gongSi">{{ item.companyName }}</div>
                <div class="sangeSpan">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :content="`${Array.isArray(item.organs) ? item.organs.join('、') : '-'}`"
                  >
                    <div slot="reference">
                      <div class="classNames">
                        所在组织:
                        <span v-if="Array.isArray(item.organs) && item.organs.length">
                          <span v-for="(item, index) in item.organs" :key="index">
                            <span style="margin-left: 8px">{{ item }}</span>
                          </span>
                        </span>
                        <span style="margin-left: 8px" v-else>-</span>
                      </div>
                    </div>
                  </el-popover>
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :content="`${Array.isArray(item.positionNames) ? item.positionNames.join('、') : '-'}`"
                  >
                    <div slot="reference">
                      <div class="classNames">
                        所在岗位:
                        <span v-if="Array.isArray(item.positionNames) && item.positionNames.length">
                          <span v-for="(item, index) in item.positionNames" :key="index">
                            <span style="margin-left: 8px">{{ item }}</span>
                          </span>
                        </span>
                        <span style="margin-left: 8px" v-else>-</span>
                      </div>
                    </div>
                  </el-popover>
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :content="`${Array.isArray(item.salesTerritory) ? item.salesTerritory.join('、') : '-'}`"
                  >
                    <div slot="reference">
                      <div class="classNames">
                        销售区域:
                        <span v-if="Array.isArray(item.salesTerritory) && item.salesTerritory.length">
                          <span v-for="(item, index) in item.salesTerritory" :key="index">
                            <span style="margin-left: 8px">{{ item }}</span>
                          </span>
                        </span>
                        <span style="margin-left: 8px" v-else>-</span>
                      </div>
                    </div>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
          <!-- 入职公司信息 end-->
          <div class="cols">
            <div class="col-itms" v-for="(j, k) in selectCompanyInforMapping" :key="k" v-show="j.displayFlag === 1">
              <div class="title" id="item">{{ j.sourceName }}：</div>
              <div class="label w300 textl" v-if="j.sourceKey !== 'medicalReport' && j.sourceKey !== 'dimissionReport'">
                {{ selectCompanyInfor[j.sourceKey] || '-' }}
              </div>
              <div class="label w300 textl" v-else>
                <div
                  class="my-active-file"
                  v-for="childItemx in getFilePath(selectCompanyInfor[j.sourceKey])"
                  :key="childItemx.path"
                >
                  <template>
                    <div class="file-name w250 nowrap" :title="childItemx.fileName || childItemx.name">
                      {{ childItemx.fileName || childItemx.name }}
                    </div>
                    <div class="file-preview" @click="onPreview(childItemx.path)">查看</div>
                    <div class="file-preview" @click="onDownload(childItemx.path)">下载</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </section>

    <div class="flow">
      <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
    </div>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" maxlength="100" placeholder="输入驳回理由（必填）" v-model="approveSuggest">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" maxlength="100" placeholder="请填写通过备注（选填）" v-model="approveSuggest">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <div class="operte-btns">
      <div class="btn cancel" @click="$router.go(-1)">取消</div>
      <div
        class="btn cancel"
        v-if="prevForm.staffGuid == staffGuid && prevForm.approveState == 'A'"
        style="margin-left: 10px"
        @click="toRevoke"
      >
        撤销
      </div>
      <div
        class="btn save"
        v-if="
          prevForm.approveStaffGuids &&
          prevForm.approveStaffGuids.indexOf(staffGuid) > -1 &&
          prevForm.approveState == 'A'
        "
        @click="
          rejectDialogVisible = true;
          approveSuggest = '';
        "
      >
        驳回
      </div>
      <div
        class="btn submit"
        v-if="
          prevForm.approveStaffGuids &&
          prevForm.approveStaffGuids.indexOf(staffGuid) > -1 &&
          prevForm.approveState == 'A'
        "
        @click="
          passDialogVisible = true;
          approveSuggest = '';
        "
      >
        通过
      </div>
    </div>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';

export default {
  components: {},
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      changeCause: '', // 花名册删除原因
      iframeSh: false,
      iframeSrc: null,
      staffGuid: userinfo.staffGuid,
      prevForm: null,
      approveSuggest: null,
      passDialogVisible: false,
      pssDialogVisible: false,
      rejectDialogVisible: false,
      allGroupData: [],
      valueNew: null,
      initValueNew: null, // 原始对象
      valueOriginal: null,
      fullscreenLoading: false,
      operateState: null,
      formConfigList: [],
      styleArr: [],
      //千分位的处理
      processDataArr: [],
      //处理显示数组(后期需要展示其他的可以自行解开)
      handlesDisplayArrays: [],
      //
      lesDisplayArr: [],
      companyInfo: {}, // 入职信息
      selectCompanyInfor: {}, // 当前选中的公司入职信息
      selectCompanyInforMapping: [],
      isActive: 0,
      hisInfoCom:'历史入职信息'
    };
  },
  computed: {
    thousandsAmounts() {
      return this.processDataArr.map((amount) => {
        return amount.toLocaleString();
      });
    },
    tenantGuidArr() {
      return Array.isArray(this.companyInfo.staffDetail) ? this.companyInfo.staffDetail : [];
    },
    // 当前变更的公司信息
    changeCompany() {
      return this.tenantGuidArr.filter((item) => item.tenantGuid === this.initValueNew.staffRecordTenantGuid)
    },
    // 其他公司列表
    otherCompanies() {
      return this.hasChangedOfCompany ? this.tenantGuidArr.filter((item) => item.tenantGuid !== this.initValueNew.staffRecordTenantGuid) : this.tenantGuidArr
    },
    // !判断valueNew中是否有入职信息的字段来判断是否有变更, 没有则不展示入职信息
    hasChangedOfCompany() {
      // 拿到mapping里的所有的sourceKey, 并排除司龄字段joinAge
      let keyList = []
      this.selectCompanyInforMapping.forEach(item=>{
        if (item.sourceKey && item.sourceKey !=='joinAge') {
          keyList.push(item.sourceKey)
        }
      })
      for (let index = 0; index < keyList.length; index++) {
        const element = keyList[index];
        if (this.initValueNew.hasOwnProperty(element)) {
          return true
        }
      }
      return false
    }
  },
  watch: {},

  created() {
    // 页面哪些需要展示照片,哪些需要展示对应的input文本,白名单
    // this.thousandthsobjArr=['probationSalary','officialSalary','salary','performanceSalary','basicSalary']
    // this.imgDisplayArea = ['medicalReport', 'dimissionReport','contractFile', 'idFrontPictContent', 'idBackPictContent']
    this.imgDisplayArea_1 = ['idFrontPictContent', 'idBackPictContent'];
    this.imgDisplayArea_2 = [
      'medicalReport',
      'dimissionReport',
      'contractFile',
      'idFrontPictContent',
      'idBackPictContent',
    ];

    if (this.$route.query.form) {
      let prevForm = JSON.parse(decodeURIComponent(this.$route.query.form));
      console.log(prevForm);
      let token = localStorage.token;
      this.changeCause = prevForm.param4;
      let camundaDeploymentId = prevForm.camundaDeploymentId;
      let camundaInstanceId = prevForm.camundaInstanceId;
      //流程展示
      this.prevForm = prevForm;
      this.iframeSh = true;
      this.iframeSrc =
        bpmnroute +
        '/iframeBpmn?processInstanceId=' +
        camundaInstanceId +
        '&camundaDeploymentId=' +
        camundaDeploymentId +
        '&token=' +
        token;
      // this.getDetail()
      this.getDetailNew();
    }
  },

  methods: {
    formatStr(num) {
      return num ? String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
    },
    // 获取详情
    getDetailPromise() {
      return new Promise((resolve, reject) => {
        this.api
          .postJson(
            `/${serverConfig.msConfigureService}/data-alter/audit/todo-config-detail-by-approval-guid?approvalGuid=${this.prevForm.guid}&dicConvert=true`,
          )
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.handlesDisplayArrays = res.data.data.formConfigList;
              this.initValueNew = JSON.parse(JSON.stringify(res.data.data.valueNew));
              this.valueNew = res.data.data.valueNew;

              this.valueOriginal = res.data.data.valueOriginal;
              let index = this.handlesDisplayArrays.findIndex((item) => item.sourceName === '入职信息');
              // if (this.valueNew) {
              //   // !没有入职公司，删除入职信息
              //   let item = this.handlesDisplayArrays.find((item) => item.sourceName === '入职信息');
              //   this.selectCompanyInforMapping = item && item.mapping ? JSON.parse(item.mapping).filter(item=>item.displayFlag === 1) : []; // !入职信息字段配置
              //   if (this.valueNew.staffRecordTenantGuid) { 
              //     if (!this.hasChangedOfCompany) {
              //       this.handlesDisplayArrays.splice(index, 1);
              //     }
              //   } else {
              //     // !没有入职公司guid 则删除入职信息配置
              //     this.handlesDisplayArrays.splice(index, 1);
              //   }
              // } else {
              //   this.handlesDisplayArrays.splice(index, 1);
              // }
              // !增加其他入职信息
              // this.handlesDisplayArrays.splice(index + 1, 0, { sourceName: this.hisInfoCom, displayFlag: 1 });//去掉历史入职信息
              if (this.valueOriginal && !this.valueNew) {
                this.operateState = 'del';
              }
              if (!this.valueOriginal && this.valueNew) {
                this.operateState = 'add';
              }
              if (this.valueOriginal && this.valueNew) {
                this.operateState = 'update';
              }
              this.formConfigList = res.data.data.formConfigList;

              this.formConfigList.forEach((item) => {
                item.mapping = item.mapping ? JSON.parse(item.mapping) : {};
              });
              resolve(this.valueOriginal || {});
            } else {
              this.$message.error(res.data.msg);
            }
          });
      });
    },
    // 获取人员入职信息
    getProfilePromise(guid) {
      return new Promise((resolve, reject) => {
        this.api.get(`/${serverConfig.msPersonnelService}/staff-roster/profile?staffGuid=${guid}`).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.companyInfo = res.data.data;
            if (this.otherCompanies[0]) this.dynamicDisplay(this.otherCompanies[0]);
            resolve(this.companyInfo);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    getDetail(callBack) {
      this.api
        .postJson(
          `/${serverConfig.msConfigureService}/data-alter/audit/todo-config-detail-by-approval-guid?approvalGuid=${this.prevForm.guid}&dicConvert=true`,
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log(res.data.data.formConfigList);
            this.handlesDisplayArrays = res.data.data.formConfigList;
            console.log(this.handlesDisplayArrays);
            this.valueNew = res.data.data.valueNew;

            this.valueOriginal = res.data.data.valueOriginal;

            if (this.valueNew) {
              // !没有入职公司，删除入职信息
              if (!this.valueNew.staffRecordTenantGuid) {
                this.handlesDisplayArrays.splice(1, 1);
              }
            } else {
              this.handlesDisplayArrays.splice(1, 1);
            }
            if (this.valueOriginal && !this.valueNew) {
              this.operateState = 'del';
            }
            if (!this.valueOriginal && this.valueNew) {
              this.operateState = 'add';
            }
            if (this.valueOriginal && this.valueNew) {
              this.operateState = 'update';
            }
            this.formConfigList = res.data.data.formConfigList;

            let mappingArr = [];
            this.formConfigList.forEach((item) => {
              item.mapping = JSON.parse(item.mapping);
              mappingArr = item.mapping;
            });
            if (callBack) {
              callBack();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    async getDetailNew() {
      let valueOriginal = await this.getDetailPromise();
      if (valueOriginal.guid) await this.getProfilePromise(valueOriginal.guid);
    },
    getValue(targetObj, operateState, type) {
      let valueOriginal = this.valueOriginal;
      let valueNew = this.valueNew;
      // console.log(valueOriginal,valueNew);
      // this.thousandthsArr.push(valueOriginal.probationSalary,valueOriginal.salary,valueOriginal.officialSalary,valueOriginal.performanceSalary,valueOriginal.basicSalary)
      // console.log(this.thousandthsArr);
      let obj = null;
      if (operateState == 'update') {
        if (type == 0) {
          //取原始值
          // return valueOriginal[targetObj.sourceKey]
          try {
            // 下面是照片的展示
            // if(['idFrontPictContent', 'idBackPictContent'].includes(targetObj.sourceKey)){
            //   const obj = JSON.parse(valueOriginal[targetObj.sourceKey])
            //   return obj['path']
            // }

            if (
              ['medicalReport', 'dimissionReport', 'contractFile', 'idFrontPictContent', 'idBackPictContent'].includes(
                targetObj.sourceKey,
              )
            ) {
              // 下面就是文件的
              obj = valueOriginal[targetObj.sourceKey] ? JSON.parse(valueOriginal[targetObj.sourceKey]) : [];
              return obj;
            }
            // if (['probationSalary','officialSalary','salary','performanceSalary','basicSalary'].includes(targetObj.sourceKey)){
            //   // 下面就是千分位的
            //   const obj= this.thousandthsArr.map(amount => amount.toLocaleString());
            //   return obj
            // }
            // return valueOriginal[targetObj.sourceKey]
          } catch (error) {
            return valueOriginal[targetObj.sourceKey];
          }
          // formatStr(valueOriginal.officialSalary)
          // console.log(this.formatStr(valueOriginal.officialSalary),'ljx');
          valueOriginal.officialSalary = this.formatStr(valueOriginal.officialSalary);
          valueOriginal.salary = this.formatStr(valueOriginal.salary);
          valueOriginal.fundBase = this.formatStr(valueOriginal.fundBase);
          valueOriginal.insPaymentBase = this.formatStr(valueOriginal.insPaymentBase);
          valueOriginal.performanceSalary = this.formatStr(valueOriginal.performanceSalary);
          valueOriginal.probationSalary = this.formatStr(valueOriginal.probationSalary);
          valueOriginal.basicSalary = this.formatStr(valueOriginal.basicSalary);
          valueNew.officialSalary = this.formatStr(valueNew.officialSalary);
          valueNew.salary = this.formatStr(valueNew.salary);
          valueNew.fundBase = this.formatStr(valueNew.fundBase);
          valueNew.insPaymentBase = this.formatStr(valueNew.insPaymentBase);
          valueNew.performanceSalary = this.formatStr(valueNew.performanceSalary);
          valueNew.probationSalary = this.formatStr(valueNew.probationSalary);
          valueNew.basicSalary = this.formatStr(valueNew.basicSalary);
          return valueOriginal[targetObj.sourceKey];
        }
        if (type == 1) {
          //加载照片
          try {
            // 下面是照片的展示
            // if(['idFrontPictContent', 'idBackPictContent'].includes(targetObj.sourceKey)){
            //   const obj = JSON.parse(valueNew[targetObj.sourceKey])
            //   return obj['path']
            // }

            if (
              ['medicalReport', 'dimissionReport', 'contractFile', 'idFrontPictContent', 'idBackPictContent'].includes(
                targetObj.sourceKey,
              )
            ) {
              // 下面就是文件的
              obj = valueNew[targetObj.sourceKey] ? JSON.parse(valueNew[targetObj.sourceKey]) : null;
              return obj;
            }
            // console.log(valueNew[targetObj.sourceKey], "ljxxxxxxxxx");
            return valueNew[targetObj.sourceKey];
          } catch (error) {
            return valueNew[targetObj.sourceKey];
          }
        }
      }
      if (operateState == 'add') {
        try {
          // 下面是照片的展示
          // if(['idFrontPictContent', 'idBackPictContent'].includes(targetObj.sourceKey)){
          //   const obj = JSON.parse(valueNew[targetObj.sourceKey])
          //   return obj['path']
          // }

          if (
            ['medicalReport', 'dimissionReport', 'contractFile', 'idFrontPictContent', 'idBackPictContent'].includes(
              targetObj.sourceKey,
            )
          ) {
            // 下面就是文件的
            obj = valueNew[targetObj.sourceKey] ? JSON.parse(valueNew[targetObj.sourceKey]) : [];
            // const str = obj.map(item => item.name).join(',')
            // console.log(str);

            return obj;
          }
        } catch (error) {
          return valueNew[targetObj.sourceKey];
        }

        valueNew.officialSalary = this.formatStr(valueNew.officialSalary);
        valueNew.salary = this.formatStr(valueNew.salary);
        valueNew.fundBase = this.formatStr(valueNew.fundBase);
        valueNew.insPaymentBase = this.formatStr(valueNew.insPaymentBase);
        valueNew.performanceSalary = this.formatStr(valueNew.performanceSalary);
        valueNew.probationSalary = this.formatStr(valueNew.probationSalary);
        valueNew.basicSalary = this.formatStr(valueNew.basicSalary);
        return valueNew[targetObj.sourceKey];
      }
      if (operateState == 'del') {
        try {
          // 下面是照片的展示
          // if(['medicalReport', 'dimissionReport','contractFile','idFrontPictContent', 'idBackPictContent'].includes(targetObj.sourceKey)){
          //   const obj = JSON.parse(valueOriginal[targetObj.sourceKey])
          //   return obj['path']
          // }

          if (['medicalReport', 'dimissionReport', 'contractFile'].includes(targetObj.sourceKey)) {
            // 下面就是文件的
            obj = valueOriginal[targetObj.sourceKey] ? JSON.parse(valueOriginal[targetObj.sourceKey]) : [];
            // const str = obj.map(item => item.name).join(',')
            // console.log(str);
            console.log(obj);
            return obj;
          }
        } catch (error) {
          return valueOriginal[targetObj.sourceKey];
        }
        valueOriginal.officialSalary = this.formatStr(valueOriginal.officialSalary);
        valueOriginal.salary = this.formatStr(valueOriginal.salary);
        valueOriginal.fundBase = this.formatStr(valueOriginal.fundBase);
        valueOriginal.insPaymentBase = this.formatStr(valueOriginal.insPaymentBase);
        valueOriginal.performanceSalary = this.formatStr(valueOriginal.performanceSalary);
        valueOriginal.probationSalary = this.formatStr(valueOriginal.probationSalary);
        valueOriginal.basicSalary = this.formatStr(valueOriginal.basicSalary);
        return valueOriginal[targetObj.sourceKey];
      }
      //取原始值

      return valueNew[targetObj.sourceKey];
    },

    //驳回提交
    toRejectSubmit() {
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.prevForm.guid,
        flowType: this.prevForm.flowType,
        funcCode: this.prevForm.funcCode,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid,
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let query = {
        guid: this.prevForm.guid,
        flowType: this.prevForm.flowType,
        funcCode: this.prevForm.funcCode,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //撤回
    toRevoke() {
      let self = this;
      this.$confirm('确定撤销吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let query = {
            guid: this.prevForm.guid,
            flowType: this.prevForm.flowType,
            funcCode: this.prevForm.funcCode,
            approveStaffGuid: this.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //展示文件
    onPreview(fileName) {
      console.log(fileName);

      //照片
      var fileSuffix = fileName ? fileName.substring(fileName.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(fileName);
      }
      // var fileSuffix = fileName.name ? fileName.name.substring(fileName.name.lastIndexOf('.') + 1) : '';
      // if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
      //   return window.open(fileName.path, fileName.name);
      // }

      // console.log(111, obj);
      //world和Excel下载
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + fileName);
    },
    //下载文件
    onDownload(fileName) {
      console.log(fileName);

      window.open(fileName + '?response-content-type=application/octet-stream');
    },
    //样式变化
    styleChanges(index) {
      this.isActive = index;
    },
    //点击公司的动态显示
    dynamicDisplay(item) {
      this.selectCompanyInfor = JSON.parse(JSON.stringify(item));
      if (this.selectCompanyInfor.entryDate)
        this.selectCompanyInfor.entryDate = this.$moment(this.selectCompanyInfor.entryDate).format('YYYY-MM-DD');
      if (this.selectCompanyInfor.regularDate)
        this.selectCompanyInfor.regularDate = this.$moment(this.selectCompanyInfor.regularDate).format('YYYY-MM-DD');
      if (this.selectCompanyInfor.dimissionDate)
        this.selectCompanyInfor.dimissionDate = this.$moment(this.selectCompanyInfor.dimissionDate).format(
          'YYYY-MM-DD',
        );

      if (this.selectCompanyInfor.dutyStatus)
        this.selectCompanyInfor.dutyStatus = this.$getNameByKey(this.selectCompanyInfor.dutyStatus, '在职状态');
      if (this.selectCompanyInfor.staffStatus)
        this.selectCompanyInfor.staffStatus = this.$getNameByKey(this.selectCompanyInfor.staffStatus, '转正状态');
      if (this.selectCompanyInfor.probationPeriod)
        this.selectCompanyInfor.probationPeriod = this.$getNameByKey(this.selectCompanyInfor.probationPeriod, '试用期');
      if (this.selectCompanyInfor.dimissionType)
        this.selectCompanyInfor.dimissionType = this.$getNameByKey(this.selectCompanyInfor.dimissionType, '离职类型');
      if (this.selectCompanyInfor.positionLevel)
        this.selectCompanyInfor.positionLevel = this.$getNameByKey(this.selectCompanyInfor.positionLevel, '职级');
    },
    getFilePath(item) {
      return item ? JSON.parse(item) : []
    }
  },
};
</script>
